'use client';

import { Box, Grid, Rating, Typography } from '@mui/material';

const ReviewStars = ({
  value = 5,
  size = 'small',
}: {
  value?: number;
  size?: 'small' | 'medium' | 'large';
}) => (
  <Rating
    value={value}
    readOnly
    precision={0.1}
    size={size}
    sx={{
      color: '#EAB308',
    }}
  />
);

const TrustpilotRating = () => {
  return (
    <Box
      // component="a"
      // href="https://www.trustpilot.com/review/taxzerone.com"
      // target="_blank"
      // rel="noopener noreferrer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        mx: 'auto',
        textDecoration: 'none',
        // cursor: 'pointer',
        transition: 'transform 0.2s ease',
        // '&:hover': {
        //   transform: 'translateY(-2px)',
        // },
        '& .trustpilot-widget iframe': { ml: '-6%' },
      }}
    >
      {/* <!-- TrustBox widget - Flex --> */}
      <div
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id="54197383fd9dceac42a68694"
        data-businessunit-id="66d1a0d64dcbafc220e052cd"
        data-style-width="110%"
        data-style-size="S"
        data-text-color="dark"
        data-headline="star"
        // data-support-text="word"
        data-background="none"
        data-external-elements-color="dark"
        data-font-family="Poppins"
      >
        <a
          href="https://www.trustpilot.com/review/taxzerone.com"
          target="_blank"
          rel="noopener"
        >
          Trustpilot
        </a>
      </div>
      {/* <!-- End TrustBox widget --> */}
    </Box>
  );
};

const G2Rating = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        textAlign: 'left',
        gap: 1.2,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        component="picture"
        sx={{
          display: 'flex',
        }}
      >
        <Box
          component="img"
          src="/assets/images/g2-logo-img.webp"
          loading="lazy"
          alt="G2 logo"
          width={53}
          height={56}
          sx={{
            width: { xs: 26, xl: 53 },
            height: { xs: 27, xl: 56 },
            objectFit: 'contain',
          }}
        />
      </Box>

      <Box sx={{ textAlign: 'left' }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: { xs: 12, xl: 14 },
          }}
        >
          Reviews 5.0
        </Typography>

        <ReviewStars value={5} />
      </Box>
    </Box>
  );
};

const GoogleRating = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        textAlign: 'left',
        gap: 1.2,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        component="picture"
        sx={{
          display: 'flex',
        }}
      >
        <Box
          component="img"
          src="/assets/images/google-reviews.webp"
          loading="lazy"
          alt="Google Review"
          width={53}
          height={56}
          sx={{
            width: { xs: 26, xl: 53 },
            height: { xs: 27, xl: 56 },
            objectFit: 'contain',
          }}
        />
      </Box>

      <Box sx={{ textAlign: 'left' }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: { xs: 12, xl: 14 },
          }}
        >
          Reviews 5.0
        </Typography>

        <ReviewStars value={5} />
      </Box>
    </Box>
  );
};

const ReviewRatings = () => {
  return (
    <Grid
      container
      spacing={0}
      maxWidth="md"
      sx={{
        mx: 'auto',
        mt: 3,
        alignContent: 'center',
        backgroundColor: '#fff',
        p: '0 !important',
      }}
    >
      {/* G2 */}
      <Grid
        size={{
          xs: 12,
          sm: 4,
          md: 3.5,
          lg: 3.5,
        }}
        sx={{
          border: '1px solid #ccc',

          py: 0,
          alignContent: 'center',
        }}
      >
        <G2Rating />
      </Grid>
      {/* Trustpilot */}
      <Grid
        size={{
          xs: 12,
          sm: 4,
          md: 5,
          lg: 5,
        }}
        sx={{
          border: '1px solid #ccc',
          borderLeft: {
            sm: 'unset',
          },
          textAlign: 'center',
          py: 0,
          alignContent: 'center',
        }}
      >
        <TrustpilotRating />
      </Grid>
      {/* Google */}
      <Grid
        size={{
          xs: 12,
          sm: 4,
          md: 3.5,
          lg: 3.5,
        }}
        sx={{
          border: '1px solid #ccc',
          borderLeft: {
            sm: 'unset',
          },
          py: 0,
          alignContent: 'center',
        }}
      >
        <GoogleRating />
      </Grid>
    </Grid>
  );
};

export default ReviewRatings;
